export default __webpack_public_path__ + "static/media/live-icon.018abd0b.webp";